export default __webpack_public_path__ + "static/arlo_logo.png";